import BulgurProduct from 'models/BulgurProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import BulgurPackage from './BulgurPackage'

const productOptions = {
  packagingInfo: <BulgurPackage />,
  productTitle: 'Bulgur',
  model: BulgurProduct,
  validCategories: ['16'],
  validSubCategories: ['004'],
}

const Bulgur = () => <ProductForm product={productOptions} />

export default Bulgur

export const getBulgurPackage = newProduct => {
  const newBulgurPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Bulgur',
    GrainSize: newProduct.GrainSize,
    Organic: newProduct.Organic,
  }
  return newBulgurPackage
}
export const updateBulgurPackage = newProduct => {
  const newBulgurPackage = {
    UPC: newProduct.UPC,
    WholeGrainType: 'Bulgur',
    GrainSize: newProduct.GrainSize,
    Organic: newProduct.Organic,
  }
  return newBulgurPackage
}
